export default __webpack_public_path__ + "resources/icons/d322-ccf9.png";